import React from 'react';

import { useErrorContext } from 'components/Patient/context/ErrorContext';
import { AlertErrorIcon } from 'components/SvgIcons';
import { AlertModal } from './AlertsModal';

export const GlobalErrorAlert: React.FC = () => {
  const { errorMessages, setErrorMessageAlert } = useErrorContext();

  if (!errorMessages || errorMessages.text?.length === 0) {
    return null;
  }

  return (
    <AlertModal
      messages={errorMessages?.text}
      title={errorMessages?.title ?? 'Unexpected error occurred'}
      icon={<AlertErrorIcon color="var(--color-error)" />}
      isOpen={errorMessages !== null}
      hideModal={() => setErrorMessageAlert(null)}
    />
  );
};
